/*
 * THE FLYING BEANS — HOMEPAGE SECTION 03: OUR STORY CONTROLLER
 * Isolated ScrollTrigger Timeline & Theme Editor Lifecycle
 * Platform: Shopify 2.0
 */

(function () {
  'use strict';

  window.TFB = window.TFB || {};

  function initStorySection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.initialized === 'true') return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      sectionEl.dataset.initialized = 'true';
      return;
    }

    var img = sectionEl.querySelector('.tfb-story__img');
    var quote = sectionEl.querySelector('.tfb-story__quote');
    var rightContent = sectionEl.querySelector('.tfb-story__content');
    var eyebrowRow = sectionEl.querySelector('.tfb-story__eyebrow-row');
    var heading = sectionEl.querySelector('.tfb-story__heading');
    var body = sectionEl.querySelector('.tfb-story__body');
    var cta = sectionEl.querySelector('.tfb-story__cta-wrap');
    var pillars = sectionEl.querySelectorAll('.tfb-story__pillar');
    var botanical = sectionEl.querySelector('.tfb-story__botanical');

    var gsapUrl = sectionEl.dataset.gsapUrl;
    var stUrl = sectionEl.dataset.scrolltriggerUrl;

    function setupAnimation(gsap, ScrollTrigger) {
      sectionEl.dataset.initialized = 'true';

      // Set initial states
      if (quote) gsap.set(quote, { y: 30, opacity: 0 });
      if (eyebrowRow) gsap.set(eyebrowRow, { y: 20, opacity: 0 });
      if (heading) gsap.set(heading, { y: 25, opacity: 0 });
      if (body) gsap.set(body, { y: 20, opacity: 0 });
      if (cta) gsap.set(cta, { y: 15, opacity: 0 });
      if (pillars.length) gsap.set(pillars, { y: 25, opacity: 0 });
      if (botanical) gsap.set(botanical, { opacity: 0, scale: 0.96 });

      // Main Entrance ScrollTrigger
      ScrollTrigger.create({
        trigger: sectionEl,
        start: 'top 80%',
        once: true,
        onEnter: function () {
          var tl = gsap.timeline({ defaults: { ease: 'power2.out' } });

          // Left Panel: Image settles & quote fades up
          if (img) {
            tl.to(img, { scale: 1, duration: 1.4, ease: 'power2.out' }, 0);
          }
          if (quote) {
            tl.to(quote, { y: 0, opacity: 1, duration: 1.0 }, 0.2);
          }

          // Right Panel: Editorial Story Stagger
          if (eyebrowRow) {
            tl.to(eyebrowRow, { y: 0, opacity: 1, duration: 0.7 }, 0.15);
          }
          if (heading) {
            tl.to(heading, { y: 0, opacity: 1, duration: 0.85 }, 0.25);
          }
          if (body) {
            tl.to(body, { y: 0, opacity: 1, duration: 0.8 }, 0.4);
          }
          if (cta) {
            tl.to(cta, { y: 0, opacity: 1, duration: 0.75 }, 0.55);
          }
          if (pillars.length) {
            tl.to(pillars, {
              y: 0,
              opacity: 1,
              duration: 0.75,
              stagger: 0.12,
              clearProps: 'transform,opacity'
            }, 0.65);
          }
          if (botanical) {
            tl.to(botanical, {
              opacity: 0.24,
              scale: 1,
              duration: 1.2,
              ease: 'power1.out',
              clearProps: 'transform,opacity'
            }, 0.3);
          }
        }
      });

      // Desktop subtle parallax on the landscape image
      if (img && window.innerWidth >= 990) {
        ScrollTrigger.create({
          trigger: sectionEl,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
          onUpdate: function (self) {
            var progress = self.progress;
            var yOffset = (progress - 0.5) * 25;
            gsap.set(img, { y: yOffset });
          }
        });
      }
    }

    if (window.gsap && window.ScrollTrigger) {
      setupAnimation(window.gsap, window.ScrollTrigger);
    } else if (typeof window.TFB.loadGSAP === 'function' && gsapUrl && stUrl) {
      window.TFB.loadGSAP(gsapUrl, stUrl)
        .then(function (ctx) {
          setupAnimation(ctx.gsap || window.gsap, ctx.ScrollTrigger || window.ScrollTrigger);
        })
        .catch(function (err) {
          console.warn('[TFB Story] GSAP load failed, falling back:', err);
          if (quote) quote.style.opacity = '1';
          if (eyebrowRow) eyebrowRow.style.opacity = '1';
          if (heading) heading.style.opacity = '1';
          if (body) body.style.opacity = '1';
          if (cta) cta.style.opacity = '1';
          pillars.forEach(function (p) { p.style.opacity = '1'; });
          if (botanical) botanical.style.opacity = '0.24';
        });
    }
  }

  function initAllStory() {
    var sections = document.querySelectorAll('.tfb-story');
    sections.forEach(function (sec) {
      initStorySection(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStory);
  } else {
    initAllStory();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList.contains('tfb-story-section')) {
      var sec = event.target.querySelector('.tfb-story');
      if (sec) {
        sec.dataset.initialized = 'false';
        initStorySection(sec);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.classList.contains('tfb-story-section')) {
      if (window.ScrollTrigger) {
        var triggers = window.ScrollTrigger.getAll();
        triggers.forEach(function (st) {
          if (event.target.contains(st.trigger)) {
            st.kill(true);
          }
        });
      }
    }
  });

})();
